(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["uhp-promo-products"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('uhp-product-carousel')) {
  customElements.define('uhp-product-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.uhp-promo__track');
      this.prev = this.querySelector('[data-promo-prev]');
      this.next = this.querySelector('[data-promo-next]');
      this.onScroll = () => this.update();
      this.prev.onclick = () => this.move(-1);
      this.next.onclick = () => this.move(1);
      this.track.addEventListener('scroll',this.onScroll,{passive:true});
      this.onKey = event => {
        if(event.target !== this.track) return;
        if(event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();this.move(event.key === 'ArrowRight' ? 1 : -1);
        }
      };
      this.track.addEventListener('keydown',this.onKey);
      this.resize = new ResizeObserver(() => this.update());
      this.resize.observe(this.track);
      this.update();
    }
    update() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      this.prev.hidden = this.next.hidden = max < 2;
      this.prev.disabled = this.track.scrollLeft <= 2;
      this.next.disabled = this.track.scrollLeft >= max - 2;
    }
    move(direction) {
      const card = this.track.querySelector('.uhp-promo__card');
      if(!card)return;
      const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap);
      const count = Math.max(1,Math.floor((this.track.clientWidth+1)/step));
      this.track.scrollBy({left:direction*step*count,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
    }
    disconnectedCallback() {
      this.resize?.disconnect();
      this.track?.removeEventListener('scroll',this.onScroll);
      this.track?.removeEventListener('keydown',this.onKey);
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["uhp-sale-notice"] && !Shopify.designMode) return;
  try {
    (() => {
  const endsAt = 1790805600000;
  const active = () => Date.now() < endsAt;
  const expire = () => {
    if (active()) return;
    document.querySelectorAll('[data-uhp-sale]').forEach(el => {el.hidden = true;});
    document.querySelectorAll('uhp-sale-carousel').forEach(el => el.expire?.());
  };
  if (!customElements.get('uhp-sale-carousel')) customElements.define('uhp-sale-carousel', class extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-sale-slide]')];
      this.index = 0;
      this.paused = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.pauseButton = this.querySelector('[data-sale-pause]');
      this.pauseButton.setAttribute('aria-pressed', String(this.paused));
      this.querySelector('[data-sale-prev]').onclick = () => {this.pause();this.show(this.index - 1);};
      this.querySelector('[data-sale-next]').onclick = () => {this.pause();this.show(this.index + 1);};
      this.pauseButton.onclick = () => {this.paused = !this.paused;this.pauseButton.setAttribute('aria-pressed',String(this.paused));};
      this.onfocusin = event => {if (event.target !== this.pauseButton) this.pause();};
      this.show(0);
      this.timer = setInterval(() => {
        if (!active()) {this.expire();return;}
        if (!this.paused && !document.hidden && !this.matches(':hover')) this.show(this.index + 1);
      }, 7000);
      if (!active()) this.expire();
    }
    pause() {this.paused = true;this.pauseButton.setAttribute('aria-pressed','true');}
    show(i) {
      this.index = (i + this.slides.length) % this.slides.length;
      this.slides.forEach((slide,n) => {slide.hidden = n !== this.index;});
      this.querySelector('[data-sale-count]').textContent = (this.index + 1) + ' / ' + this.slides.length;
    }
    expire() {clearInterval(this.timer);this.show(1);this.querySelector('.uhp-sale-controls').hidden = true;}
    disconnectedCallback() {clearInterval(this.timer);}
  });
  const configElement = document.getElementById('uhp-sale-config');
  if (configElement && !customElements.get('uhp-sale-progress')) {
    const config = JSON.parse(configElement.textContent);
    const ids = new Set(config.ids);
    let store;
    import('cart-store').then(module => {
      store = module.default;
      document.querySelectorAll('uhp-sale-progress').forEach(el => el.connectStore());
    }).catch(() => {});
    customElements.define('uhp-sale-progress', class extends HTMLElement {
      connectedCallback() {
        this.listener = event => this.update(event.detail?.cart);
        document.addEventListener('on:cart:loaded',this.listener);
        try {this.update(JSON.parse(document.getElementById('cart-data').textContent));} catch {}
        this.connectStore();
      }
      connectStore() {
        if (!store || this.unsubscribe) return;
        this.update(store.getState().cart);
        this.unsubscribe = store.subscribe(state => this.update(state.cart));
      }
      update(cart) {
        if (!cart || !Array.isArray(cart.items)) return;
        this.hidden = !active() || (cart.currency && cart.currency !== 'NOK');
        const subtotal = cart.items.reduce((sum,item) => sum + (ids.has(String(item.product_id)) && !item.selling_plan_allocation ? item.original_line_price : 0),0);
        const target = subtotal < 80000 ? 80000 : 150000;
        const amount = new Intl.NumberFormat('nb-NO',{style:'currency',currency:'NOK',maximumFractionDigits:2}).format(Math.max(0,target - subtotal)/100);
        const message = subtotal >= 150000 ? config.achieved : (subtotal >= 80000 ? config.gap25 : config.gap20).replace('[amount]',amount);
        this.querySelector('[data-sale-message]').textContent = message;
        this.querySelector('progress').value = Math.min(150000,subtotal);
      }
      disconnectedCallback() {this.unsubscribe?.();this.unsubscribe = null;document.removeEventListener('on:cart:loaded',this.listener);}
    });
  }
  expire();
  setInterval(expire,30000);
})();
  } catch(e) { console.error(e); }
})();

})();
